@let config = store.paginationConfigSg();
@let pagination = store.paginationSg();

@if (config) {
  <div class="atn-ds-table-pagination">
    <div class="atn-ds-table-pagination__page-size">
      @if (pageSizeItemsSg().length) {
        <span class="atn-ds-table-pagination__page-size-label">
          Rows per page
        </span>
        <div class="atn-ds-table-pagination__page-size-select">
          <atn-ds-select-single
            [items]="pageSizeItemsSg()"
            [required]="true"
            [value]="config.pageSize"
            (valueChange)="store.changePageSize($event)"
          />
        </div>
      }
    </div>

    <div class="atn-ds-table-pagination__navigation">
      <button
        class="atn-ds-table-pagination__navigation-button"
        [disabled]="!pagination.hasPrevious"
        type="button"
        (click)="store.changePage(pagination.page - 1)"
      >
        &lt; Prev
      </button>

      @for (page of pagination.pages; track $index) {
        @if (page === undefined) {
          <span class="atn-ds-table-pagination__navigation-page">...</span>
        } @else if (page === pagination.page) {
          <div class="atn-ds-table-pagination__selected-page">
            <atn-ds-text
              [disabled]="pagination.pageInputDisabled"
              [value]="pagination.page.toString()"
              (change)="pageChangeHandler($event)"
            />
          </div>
        } @else {
          <button
            class="atn-ds-table-pagination__navigation-button"
            type="button"
            (click)="store.changePage(page)"
          >
            {{ page }}
          </button>
        }
      }

      @if (!pagination.pages.length) {
        <div class="atn-ds-table-pagination__selected-page">
          <atn-ds-text
            [disabled]="pagination.pageInputDisabled"
            [value]="pagination.page.toString()"
            (change)="pageChangeHandler($event)"
          />
        </div>
      }

      <button
        class="atn-ds-table-pagination__navigation-button"
        [disabled]="!pagination.hasNext"
        type="button"
        (click)="store.changePage(pagination.page + 1)"
      >
        Next &gt;
      </button>
    </div>

    <span class="atn-ds-table-pagination__range">
      {{ pagination.rangeLabel }}
    </span>
  </div>
}
